import { FC } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Breadcrumbs from 'components/Breadcrumbs';
import MenuCard from 'components/MenuCard';
import PagesCard from 'components/PagesCard';
import WhatToSeeCard from 'components/WhatToSeeCard';
import PoiCard from 'components/PoiCard';

const ContentPage: FC = () => (
  <Box>
    <Breadcrumbs breadcrumbs={[{ name: 'Turinys' }]} />

    <Grid container spacing={2}>
      <MenuCard />
      <PagesCard />
      <WhatToSeeCard />
      <PoiCard />
    </Grid>
  </Box>
);

export default ContentPage;
